// Enum defining the available time periods used across the application
export enum Period {
  YEAR_TO_DATE = "YEAR_TO_DATE",
  YEAR_ELAPSED_MONTH = "YEAR_ELAPSED_MONTH",
  CURRENT_MONTH = "CURRENT_MONTH",
  LAST_MONTH = "LAST_MONTH",
  PREVIOUS_YEAR = "PREVIOUS_YEAR",
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_4_MONTHS = "LAST_4_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  TWO_YEARS_AGO = "TWO_YEARS_AGO",
}
